export const m = {
  EnterID: "Klik untuk memasukkan ID Tada",
  "select-specifications": "Klik untuk memilih spesifikasi isi ulang",
  "check-account": "Periksa akun isi ulang",
  whatID: "Apanya ID Tada?",
  getID: "Masukkan ID Tada",
  maskgetID: "Masukkan ID Tada",
  "toastTips-format-error": "Format dimasukkan salah",
  "toastTips-no-exist": "ID tidak ada",
  toastTipsPlease: "Silakan periksa akun isi ulang terlebih dahulu",
  "common-problem": "Masalah umum",
  "transaction-succeeded": "Transaksi berhasil",
  "transaction-failed": "Transaksi gagal",
  "transaction-cancel": " Transaksi dibatalkan",
  "whether-account":
    "1.Bagaimana memeriksa apakah saya telah dikreditkan setelah mengisi ulang?",
  "answer-whether-account":
    "Setelah mengisi ulang, Anda dapat kembali ke [Saya] - [Dompet] dalam app untuk melihat berlian",
  "no-account":
    "2.Bagaimana jika akun saya tidak dikreditkan setelah mengisi ulang?",
  "answer-no-account":
    "Silakan kirimkan pertanyaan Anda di [Pesan] - [Berita Resmi] - [Umpan Balik dan Bantuan] dalam app, dan berikan informasi berikut, layanan pelanggan kami akan membantu Anda.",
  "recharge-money": "1. Jumlah dan ID akun isi ulang",
  "recharge-time": "2. Waktu dan tanggal isi ulang",
  "recharge-shot": "3. Tangkapan layar pembayaran yang berhasil",
  "recharge-wrong":
    "3.Apa harus dilakukan jika saya mengisi akun yang salah atau mengisi jumlah yang salah",
  "answer-recharge-wrong":
    "Sebelum memasukkan kata sandi pembayaran, silakan cermat mengkonfirmasi ID akun isi ulang dan informasi jumlah isi ulang sebelum melakukan pembelian. Jumlah isi ulang yang salah tidak dapat dikembalikan. Mengisi ulang ke akaun yang salah, Anda dapat mencoba menghubungi pengguna ID yang benar-benar telah menagih, dan bernegosiasi dengan pihak lain apakah dia bersedia untuk mengkompensasi tagihan Anda.",
  refund: "4.Pengembalian dana",
  "answer-refund":
    "Maaf! Tada saat ini tidak mendukung pengembalian uang berbentuk apa.",
  "buy-enter-link":
    'Pembelian berlian dapat diisi ulang melalui tautan, <a class="web-link" href="http://pay.tadachat.info/" >http://pay.tadachat.info</a> menyalin tautan di browser ponsel untuk membuka, masuk ke halaman pembelian, setelah memeriksa akun, pilih spesifikasi yang sesuai dan gunakan metode pembayaran yang sesuai untuk membayar ~ Banyak diskon!',
  "buy-notice-a":
    "Catata:<a>pay.tadachat.info</a> adalah satu-satunya situs web pembelian berlian resmi untuk Tada",
  replace: "Ubah",
  sureBtn: "Tentukan",
  "pay-style": "Pilih metode pembayaran",
  goBack: "Kembali ke beranda",
  toastTips: "Masukkan ID Tada",
  rechargeFAQ_title: "Masalah umum",
  PayStatusSuccess_title: "Transaksi berhasil",
  PayStatusFail_title: "Transaksi gagal",
  PayStatusCancel_title: " Transaksi dibatalkan",
  Diamonds_title: "Situs web isi ulang berlian resmi Tada",
  "buy-notice":
    "Catatan pay.Tadachat.info adalah satu-satunya situs web pembelian berlian resmi dari Tada. Untuk pertanyaan layanan pelanggan, silakan kunjungi [Pesan] - [Berita Resmi] - [Umpan Balik dan Bantuan]",
  RechargeHelp_title: "Bantuan isi ulang",
  openAPP: "Buka aplikasi Tada",
  "buy-diamonds-tit": "Beli Layanan berlian",
  description:
    "Satu-satunya web isi ulang berlian resmi Tada. Tada adalah app sosial internasional, pengguna berada di lebih dari 150 negara dan wilayah di seluruh dunia sedang menggunakan Tada",
  keywords:
    "Isi ulang Tada, isi ulang berlian Tada, isi ulang resmi Tada, situs web isi ulang resmi Tada",
  payforType: "Metode isi ulang",
  trueText: "Tentukan",
  falseText: "Batal",
  alertShowTxt1: "Apakah Anda yakin menggunakan",
  alertShowTxt3: "untuk mengisi ulang berlian",
  alertShowTxt5: "",
  EnterIDTip: "Isi ulang cepat Tada",
  scanLogin: "Untuk privasi dan keamanan akun, harap pindai kode untuk masuk",
  scanTip:
    'Ti: Klik "Pindai" di sudut kanan atas "Pusat Pribadi / Dinamika" Tada untuk memindai kode untuk masuk. Pada saat yang sama, mendukung untuk masuk dengan mengidentifikasi tangkapan layar kode QR',
  scanVersion: "Harap tingkatkan Tada ke versi %s dan pindai kode untuk masuk",
  delAccount: "Penghapusan akun",
  logout: "Keluar",
  submit: "Kirim",
  email_place_holder: "Masukkan alamat emailmu",
  contact_email: "Kontak Email",
  provide_email:
    "Harap berikan alamat email Anda untuk menerima pemberitahuan pembayaran",
  email_address: "Alamat email",
  reseller: "Pengecer",
};



// WEBPACK FOOTER //
// ./src/lang/id.js